export class HtmlValidationException extends Error {

	constructor(type: string) {
		super(`HTML validation: ${type}.`);
		this.name = "HtmlValidationException";
	}
}
